



export function getQuestionPool(topic) {
    switch (topic) {
  
      /* ----------------------------------------------------------
         CH 1: advancedFunctions
      ---------------------------------------------------------- */
      case "advancedFunctions":
        return [
          {
            question: () => ({
              q: `
                <p>If <code>f(x) = x^2</code> and 
                <code>g(x) = f(x - 3) + 2</code>, what transformation 
                does <code>g</code> represent relative to <code>f</code>?</p>
              `,
              a: "Shift right 3, up 2",
              distract: [
                "Shift left 3, up 2",
                "Shift right 2, up 3",
                "Reflect over x-axis"
              ]
            })
          },
          {
            question: () => ({
              q: `
                <p>If <code>(f∘g)(x) = f(g(x))</code>, which is correct 
                for <code>f(x)=x+1</code> and <code>g(x)=2x</code>?</p>
              `,
              a: "<code>(f∘g)(x) = 2x + 1</code>",
              distract: [
                "<code>(f∘g)(x) = 2(x + 1)</code>",
                "<code>(f∘g)(x) = 2x + 2</code>",
                "<code>(f∘g)(x) = 2(x - 1)</code>"
              ]
            })
          },
          {
            question: () => ({
              q: `
                <p>A function <code>h</code> is piecewise: 
                <code>h(x)=x</code> if <code>x &lt; 0</code>, 
                and <code>h(x)=x^2</code> if <code>x &ge; 0</code>. 
                What is <code>h(-2)</code>?</p>
              `,
              a: "−2",
              distract: ["4", "−4", "2"]
            })
          },
          {
            question: () => ({
              q: `
                <p>If <code>f(x)=3x - 5</code>, 
                <code>g(x)=-2x + 1</code>, then 
                <code>(f + g)(x)</code> = ?</p>
              `,
              a: "<code>x - 4</code>",
              distract: [
                "<code>5x - 4</code>",
                "<code>-5x + 4</code>",
                "<code>-x + 6</code>"
              ]
            })
          },
          {
            question: () => ({
              q: `
                <p>If <code>y = -2 f(x)</code>, 
                how does that relate to <code>y=f(x)</code>?</p>
              `,
              a: "Reflection in x-axis & vertical stretch by 2",
              distract: [
                "Reflection in y-axis & stretch by 2",
                "Vertical shift by 2",
                "No transformation"
              ]
            })
          }
        ];
  
      /* ----------------------------------------------------------
         CH 2: polynomialFunctions
      ---------------------------------------------------------- */
      case "polynomialFunctions":
        return [
          {
            question: () => ({
              q: `
                <p>A polynomial with degree 5 and negative leading coefficient
                has end behavior: ?</p>
              `,
              a: "Up on left, down on right (↗︎↘︎)",
              distract: [
                "Down on left, up on right",
                "Both ends up",
                "Both ends down"
              ]
            })
          },
          {
            question: () => ({
              q: `
                <p>Factor <code>x^3 - 8</code>:</p>
              `,
              a: "<code>(x - 2)(x^2 + 2x + 4)</code>",
              distract: [
                "<code>(x - 2)(x^2 - 2x + 4)</code>",
                "<code>(x - 8)(x + 1)(x + 1)</code>",
                "<code>(x - 2)^3</code>"
              ]
            })
          },
          {
            question: () => ({
              q: `
                <p> If <code>(x - 1)</code> is a factor of <code>P(x)</code>, 
                what must be true?</p>
              `,
              a: "<code>P(1)=0</code>",
              distract: [
                "<code>P(-1)=0</code>",
                "<code>P(1)=1</code>",
                "<code>P(-1)=1</code>"
              ]
            })
          },
          {
            question: () => ({
              q: `
                <p>A quartic polynomial can have at most how many real roots?</p>
              `,
              a: "4",
              distract: ["2","3","5"]
            })
          },
          {
            question: () => ({
              q: `
                <p>Dividing <code>f(x)</code> by <code>(x - r)</code> 
                yields remainder 0. Then <code>r</code> is?</p>
              `,
              a: "A root of f(x)",
              distract: [
                "A vertical asymptote",
                "A repeated complex root",
                "No significance"
              ]
            })
          }
        ];
  
      /* ----------------------------------------------------------
         CH 3: rationalFunctions
      ---------------------------------------------------------- */
      case "rationalFunctions":
        return [
          {
            question: () => ({
              q: `
                <p>If <code>y = (x - 1)/(x + 2)</code>, 
                which <code>x</code>‐value is excluded from the domain?</p>
              `,
              a: "x=−2",
              distract: ["x=1","x=2","No restrictions"]
            })
          },
          {
            question: () => ({
              q: `
                <p><code>y = (x^2 - 4)/(x - 2)</code> simplifies to?</p>
              `,
              a: "<code>x + 2</code> (with x≠2)",
              distract: [
                "<code>x - 2</code>",
                "<code>(x + 2)/(x - 2)</code>",
                "No simplification possible"
              ]
            })
          },
          {
            question: () => ({
              q: `
                <p>If <code>f(x) = (3x + 1)/(x - 4)</code>, 
                there's a vertical asymptote at?</p>
              `,
              a: "x=4",
              distract: ["y=4","x=−4","No asymptote"]
            })
          },
          {
            question: () => ({
              q: `
                <p>If a rational function has the same degree in numerator & denominator,
                the horizontal asymptote is the ratio of leading coefficients. True or false?</p>
              `,
              a: "True",
              distract: [
                "False",
                "Depends on factorization",
                "No horizontal asymptote in that case"
              ]
            })
          },
          {
            question: () => ({
              q: `
                <p>Which is a correct partial fraction form for 
                <code>(5x + 2) / ((x+1)(x+3))</code>?</p>
              `,
              a: "<code>A/(x+1) + B/(x+3)</code>",
              distract: [
                "<code>A(x+1) + B(x+3)</code>",
                "<code>(5x+2)(x+1)/(x+3)</code>",
                "<code>(x+1)(x+3)/(5x+2)</code>"
              ]
            })
          }
        ];
  
      /* ----------------------------------------------------------
         CH 4: exponentialLog
      ---------------------------------------------------------- */
      case "exponentialLog":
        return [
          {
            question: () => ({
              q: `
                <p><code>log_a(x^m)</code> = ?</p>
              `,
              a: "<code>m · log_a(x)</code>",
              distract: [
                "<code>log_a(m·x)</code>",
                "<code>log_a(x) + log_a(m)</code>",
                "<code>m + x</code>"
              ]
            })
          },
          {
            question: () => ({
              q: `
                <p>If <code>2^x = 10</code>, then <code>x</code> = ?</p>
              `,
              a: "<code>log_2(10)</code>",
              distract: ["<code>log_10(2)</code>","x=5","No real solution"]
            })
          },
          {
            question: () => ({
              q: `
                <p>Solve <code>e^x = 1</code> => <code>x</code>=?</p>
              `,
              a: "0",
              distract: ["1","ln(1)=1","No solution"]
            })
          },
          {
            question: () => ({
              q: `
                <p>The inverse of <code>y=3^x</code> is <code>y=log_3(x)</code>. True?</p>
              `,
              a: "Yes, exactly",
              distract: [
                "No, y=1/log_3(x)",
                "No, y=ln(3x)",
                "No real inverse"
              ]
            })
          },
          {
            question: () => ({
              q: `
                <p>If <code>10^(x+1)=100</code>, <code>x</code>=?</p>
              `,
              a: "1",
              distract: ["2","−1","(x+1)=2 => x=1"]
            })
          }
        ];
  
      /* ----------------------------------------------------------
         CH 5: trigIdentities
      ---------------------------------------------------------- */
      case "trigIdentities":
        return [
          {
            question: () => ({
              q: `
                <p><code>sin^2(x) + cos^2(x)</code> = ?</p>
              `,
              a: "1",
              distract: [
                "<code>sec^2(x)</code>",
                "<code>tan^2(x)</code>",
                "No identity"
              ]
            })
          },
          {
            question: () => ({
              q: `
                <p><code>cos(A + B)</code> = ?</p>
              `,
              a: "<code>cosA cosB − sinA sinB</code>",
              distract: [
                "<code>cosA cosB + sinA sinB</code>",
                "<code>sinA sinB − cosA cosB</code>",
                "<code>cosA + cosB</code>"
              ]
            })
          },
          {
            question: () => ({
              q: `
                <p>Double‐angle formula for <code>sin(2x)</code> = ?</p>
              `,
              a: "<code>2 sin(x) cos(x)</code>",
              distract: [
                "<code>sin^2(x) + cos^2(x)</code>",
                "<code>sin^2(x) − cos^2(x)</code>",
                "No direct formula"
              ]
            })
          },
          {
            question: () => ({
              q: `
                <p><code>1 + tan^2(x)</code> = ?</p>
              `,
              a: "<code>sec^2(x)</code>",
              distract: [
                "<code>csc^2(x)</code>",
                "<code>tan^2(x) + sin^2(x)</code>",
                "None of these"
              ]
            })
          },
          {
            question: () => ({
              q: `
                <p>Simplify: <code>sin(x)/cos(x)</code> = ?</p>
              `,
              a: "tan(x)",
              distract: ["cot(x)","sec(x)","sin(2x)"]
            })
          }
        ];
  
      /* ----------------------------------------------------------
         CH 6: sinusoidalFunctions
      ---------------------------------------------------------- */
      case "sinusoidalFunctions":
        return [
          {
            question: () => ({
              q: `
                <p>In <code>y = A·sin(B(x - C)) + D</code>, 
                what is the period?</p>
              `,
              a: "<code>2π / B</code>",
              distract: [
                "<code>B / (2π)</code>",
                "<code>(B · 2π)</code>",
                "No fixed period"
              ]
            })
          },
          {
            question: () => ({
              q: `
                <p>If the amplitude is 4, which form is correct?</p>
              `,
              a: "<code>y = 4 · sin(x - φ) + k</code>",
              distract: [
                "Amplitude=1 => y=sin(4x)",
                "y=1/4 sin(x)",
                "None are correct"
              ]
            })
          },
          {
            question: () => ({
              q: `
                <p>A sinusoid with midline <code>y=2</code>, max at <code>y=5</code> => amplitude=?</p>
              `,
              a: "3",
              distract: ["2","5","1"]
            })
          },
          {
            question: () => ({
              q: `
                <p>Phase shift means a horizontal shift left or right. True?</p>
              `,
              a: "True",
              distract: ["False","Only vertical shifts matter","No such concept"]
            })
          },
          {
            question: () => ({
              q: `
                <p><code>cos(x)</code> is a shift of <code>sin(x)</code> by how much?</p>
              `,
              a: "π/2 left (or 90° left)",
              distract: ["π/2 right","π/4 left","They are unrelated"]
            })
          }
        ];
  
      /* ----------------------------------------------------------
         CH 7: advancedEquations
      ---------------------------------------------------------- */
      case "advancedEquations":
        return [
          {
            question: () => ({
              q: `
                <p>A system with <code>x^3</code> &amp; an exponential 
                typically requires...?</p>
              `,
              a: "Graphical or numeric methods (no simple factorization)",
              distract: [
                "Simple factoring always works",
                "No real solutions",
                "We solve purely by partial fractions"
              ]
            })
          },
          {
            question: () => ({
              q: `
                <p>Solve <code>x^2 = 2^x</code> exactly in integers. Which are solutions?</p>
              `,
              a: "x=2, x=4",
              distract: ["x=1 only","No integer solutions","x=2 only"]
            })
          },
          {
            question: () => ({
              q: `
                <p>If an equation is <code>ln(x)=x</code>, does it have an elementary closed-form solution?</p>
              `,
              a: "No, we approximate or use Lambert W function",
              distract: [
                "Yes, x=0",
                "Yes, x=1",
                "Yes, x=-1"
              ]
            })
          },
          {
            /* Q4 — Solving a nonlinear system */
            question: () => ({
              q: `
                <p>When two nonlinear equations
                <em>f(x, y) = 0</em> and <em>g(x, y) = 0</em> have no obvious algebraic solution,
                which approach is commonly used to approximate their intersection(s)?</p>
              `,
              a: "Apply an iterative numerical method such as Newton–Raphson on the system",
              distract: [
                "Multiply the two equations together and solve the product",
                "Replace both equations with tangent lines and solve that single linear system",
                "There is no method—nonlinear systems cannot be solved numerically"
              ]
            })
          },
          {
            question: () => ({
              q: `
                <p>Parametric equations use a parameter <code>t</code>. 
                <code>(x(t), y(t))</code> can represent curves. True?</p>
              `,
              a: "True",
              distract: ["False","No meaning in Grade 12","They’re only for circles"]
            })
          }
        ];
  
      /* ----------------------------------------------------------
         CH 8: combinatorics
      ---------------------------------------------------------- */
      case "combinatorics":
        return [
          {
            question: () => ({
              q: `
                <p>5 distinct objects, pick 3 in order => # permutations?</p>
              `,
              a: "5P3=60",
              distract: ["5C3=10","15","30"]
            })
          },
          {
            question: () => ({
              q: `
                <p><code>(x + y)^4</code> => total # terms in expanded form (before combining like terms)?</p>
              `,
              a: "5",
              distract: ["4","8","16"]
            })
          },
          {
            question: () => ({
              q: `
                <p><code>C(n,k)</code> = ?</p>
              `,
              a: "<code>n! / [ k! (n - k)! ]</code>",
              distract: [
                "<code>n! / (n - k)!</code>",
                "<code>k!(n - k)! / (n!)</code>",
                "No closed form"
              ]
            })
          },
          {
            question: () => ({
              q: `
                <p>Distributing 4 identical balls into 2 boxes => # ways?</p>
              `,
              a: "5",
              distract: ["6","8","4^2=16"]
            })
          },
          {
            question: () => ({
              q: `
                <p>For “combinations with repetition,” the formula is <code>C(n+r-1, r)</code>. True?</p>
              `,
              a: "Yes, that’s correct",
              distract: [
                "No, that’s permutations with repetition",
                "No formula for that",
                "Only works if n<r"
              ]
            })
          }
        ];
  
      /* ----------------------------------------------------------
         CH 9: probabilityStats
      ---------------------------------------------------------- */
      case "probabilityStats":
        return [
          {
            question: () => ({
              q: `
                <p>In a normal distribution, ~68% of data is within 1 std dev. True?</p>
              `,
              a: "True",
              distract: ["False","Only 50%","95%"]
            })
          },
          {
            question: () => ({
              q: `
                <p>The standard normal distribution has <code>μ=0</code> and <code>σ=1</code>. True?</p>
              `,
              a: "Yes, that’s the definition",
              distract: [
                "No, μ=1, σ=0",
                "No standard is μ=1, σ=1",
                "No normal distribution is standard"
              ]
            })
          },
          {
            question: () => ({
              q: `
                <p><code>P(A ∪ B) = P(A) + P(B) - P(A ∩ B)</code>. True?</p>
              `,
              a: "Yes, that’s correct",
              distract: [
                "No, <code>P(A ∩ B)= P(A)+P(B)</code>",
                "Union formula is <code>P(A)+P(B)</code>",
                "No well-defined formula"
              ]
            })
          },
          {
            question: () => ({
              q: `
                <p>10 coin flips, define X=number of heads => distribution type?</p>
              `,
              a: "Binomial with n=10, p=0.5",
              distract: [
                "Poisson with λ=5",
                "Normal approx for large n=10 only",
                "Uniform"
              ]
            })
          },
          {
            question: () => ({
              q: `
                <p><code>z = (x - μ) / σ</code> is the standardization formula. True?</p>
              `,
              a: "Yes",
              distract: [
                "No, <code>z = μ / (x - σ)</code>",
                "No standardization in normal distributions",
                "Yes, but only if x ≥ μ"
              ]
            })
          }
        ];
  
      /* ----------------------------------------------------------
         CH 10: calcIntro
      ---------------------------------------------------------- */
      case "calcIntro":
        return [
          {
            question: () => ({
              q: `
                <p><code>lim (x→2) [(x^2 - 4)/(x - 2)]</code>, factoring => result is?</p>
              `,
              a: "4",
              distract: ["0","∞","-∞"]
            })
          },
          {
            question: () => ({
              q: `
                <p>The derivative measures the slope of the tangent line. True?</p>
              `,
              a: "True",
              distract: [
                "False, it’s the slope of a secant",
                "No meaning",
                "Always zero"
              ]
            })
          },
          {
            question: () => ({
              q: `
                <p>If <code>f(x)=x^2</code>, then <code>f'(x)=?</code></p>
              `,
              a: "2x",
              distract: ["x","2x+1","No derivative in pre-calc"]
            })
          },
          {
            question: () => ({
              q: `
                <p>Evaluate <code>lim (h→0) [ (x+h)^2 - x^2 ] / h</code> => ?</p>
              `,
              a: "2x",
              distract: ["x^2","2x+1","No limit exists"]
            })
          },
          {
            question: () => ({
              q: `
                <p>The concept of limit underlies continuity and derivatives. True?</p>
              `,
              a: "Yes, absolutely",
              distract: [
                "No, it’s separate",
                "Only for discrete math",
                "We never use limits again"
              ]
            })
          }
        ];
  
      default:
        return [];
    }
  }